/* RESPONSIBLE TEAM: team-proactive-support */
import PanelConfiguration from 'embercom/objects/content-editor/panel-configuration';
import GenericTriageHeaderConfiguration from 'embercom/objects/content-editor/panels/custom/ai-agent-profile/generic-triage/header-configuration';
import ComponentConfiguration from 'embercom/objects/content-editor/component-configuration';
import { assert } from '@ember/debug';
import { contentEditors } from 'embercom/models/data/matching-system/matching-constants';
import { inject as service } from '@ember/service';

export default class GenericTriagePanelConfiguration extends PanelConfiguration {
  @service contentEditorService;

  init(inputs) {
    // The container gives us access to Services in these objects. Pass `container: getOwner(this)` as an
    // input when generating these configuration objects.
    assert('You must provide the application container in your panel inputs', inputs.container);
    let header = GenericTriageHeaderConfiguration.create({ container: inputs.container });
    let body = ComponentConfiguration.create({
      component: 'content-editor/panels/custom/ai-agent-profile/generic-triage/body',
    });
    super.init({
      name: 'custom/ai-agent-profile/generic-triage',
      header,
      body,
      supportedEditors: [contentEditors.standalone],
    });
  }

  get isDisabled() {
    return !this.contentEditorService.activeObject.modeEligibleForGenericTriage;
  }
}
